import { ReactElement } from 'react';
import { IPredictionImage } from '../../jobPredictions.model';
import { TRAINING_VARIANT } from '../../jobs.model';
import { IJobThreshold } from '../../jobThreshold.store';
import { AnomalyDetectionInspector } from './contents/AnomalyDetectionInspector';
import { LocateObjectsInspector } from './contents/LocateObjectsInspector';
import { LocatePointsInspector } from './contents/LocatePointsInspector';
import { ObjectClassificationInspector } from './contents/ObjectClassificationInspector';

interface IInspectorPredictionProps {
  data: IPredictionImage;
  thresholdConfig: IJobThreshold | null;
  variant: TRAINING_VARIANT | null;
  handleTogglePredictionClassId: (classId: string) => () => void;
  predictionClassIds: string[];
}

export const InspectorPrediction = ({
  data,
  thresholdConfig,
  variant,
  predictionClassIds,
  handleTogglePredictionClassId,
}: IInspectorPredictionProps): ReactElement => {
  switch (variant) {
    case TRAINING_VARIANT.ANOMALY_DETECTION_4:
    case TRAINING_VARIANT.ANOMALY_DETECTION_7:
    case TRAINING_VARIANT.ANOMALY_DETECTION_8: {
      const threshold =
        thresholdConfig && thresholdConfig.minThreshold !== null && thresholdConfig.maxThreshold !== null
          ? [thresholdConfig.minThreshold, thresholdConfig.maxThreshold]
          : null;
      return (
        <AnomalyDetectionInspector
          score={data.prediction.score}
          threshold={threshold}
          groundTruth={data.prediction.groundTruth}
        />
      );
    }
    case TRAINING_VARIANT.OBJECT_CLASSIFICATION:
      return (
        <ObjectClassificationInspector
          groundTruth={data.prediction.groundTruth?.className}
          confidence={data.prediction.confidence}
          prediction={data.prediction.prediction}
        />
      );
    case TRAINING_VARIANT.LOCATE_POINTS:
      return (
        <LocatePointsInspector
          threshold={thresholdConfig?.optimalThreshold ?? 0}
          groundTruth={data.prediction.groundTruth}
          predictedPoints={data.predictedPoints}
          predictionClassIds={predictionClassIds}
          handleTogglePredictionClassId={handleTogglePredictionClassId}
        />
      );
    case TRAINING_VARIANT.LOCATE_OBJECTS:
      return (
        <LocateObjectsInspector
          threshold={thresholdConfig?.optimalThreshold ?? 0}
          groundTruth={data.prediction.groundTruth}
          predictedRectangles={data.predictedRectangles}
          predictionClassIds={predictionClassIds}
          handleTogglePredictionClassId={handleTogglePredictionClassId}
        />
      );
    case null: {
      throw new Error('Not implemented yet: null case');
    }
    case TRAINING_VARIANT.FEATURE_DETECTION:
    default:
      return <></>;
  }
};
